import React from 'react'
import { Link } from 'react-router-dom'
import FormSF from '../../../widgets/form/FormSF'
import CardUI from '../../../widgets/layout/CardUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
import ButtonTinyWithSpinnerUI from '../../../widgets/action/ButtonTinyWithSpinnerUI'
import FileUploadModalSF from '../../../widgets/form/FileUploadModalSF'

const MCADataCollectionUI = ({ context, account,
  onMCASubmit, mcaSubmitted, mcaSuccessMsg, mcaErrorList, setMCAErrorList, mcaFileList,
  onDownloadFileClick, fileErrorList, mcaReuploadSubmitted, onMCAReuploadClick,
  mcaJsonUploadMode, onMcaJsonUploadClick, onMcaJsonCancelUploadClick, onMcaJsonUpload,
  mcaExcelUploadMode, onMcaExcelUploadClick, onMcaExcelCancelUploadClick, onMcaExcelUpload
}) =>
  <CardUI title='MCA data collection' className='g_m_top_50'>
    <div className='g_flex_h g_flex_top'>
      <div className='g_flex_v'>
        {
          account.documentStatus.mcaReferenceId &&
          <span className='g_muted'>Ref id: {account.documentStatus.mcaReferenceId}</span>
        }
        {
          <>
            {
              mcaFileList != null && mcaFileList.map((item) =>
                <Link className='g_m_right_50' onClick={onDownloadFileClick} to='#' data-type='mca' data-file-name={item}>
                  {item}
                </Link>)
              //<span>{item}<br></br></span>)
            }
            {
              fileErrorList && fileErrorList.length > 0 &&
              <span>{fileErrorList[0].message}</span>
            }
          </>
        }
      </div>
      <div className='g_flex_v g_text_right'>
        <span><BadgeUI label={account.documentStatus.mcaReceiveStatus} /></span>
        {
          account.documentStatus.mcaReceiveStatus !== 'not_initiated' &&
          <span className='g_muted'>{account.documentStatus.mcaStatusDateF1}</span>
        }
      </div>
    </div>

    <div className='g_flex_h g_m_top_50'>
      <span className='g_muted'>
        MCA data is collected automatically upon KYC.<br />
        It can also be intiated manually by clicking the button.<br />
        If company does not have CIN, then MCA data is not available.
      </span>
      <span className='g_text_right'>
        <FormSF context={context} buttonLabel='Initiate MCA Data Collection'
          onSubmit={onMCASubmit} busy={mcaSubmitted} inlineButton={true}
          successMsg={mcaSuccessMsg} errorList={mcaErrorList} setErrorList={setMCAErrorList}
        />
      </span>
    </div>
    <ButtonTinyWithSpinnerUI className='g_m_top_25 g_text_right'
      label='Reupload MCA data from S3 to DB'
      onClick={onMCAReuploadClick} alignLeft={false}
      busy={mcaReuploadSubmitted}
    />
    {
      context.permissions.includes('su_superuser_business') &&
      <>
        <ButtonTinyWithSpinnerUI className='g_m_top_25 g_text_right'
          label='Upload MCA JSON file'
          onClick={onMcaJsonUploadClick} alignLeft={false}
        />
        <ButtonTinyWithSpinnerUI className='g_m_top_25 g_text_right'
          label='Upload MCA Excel file'
          onClick={onMcaExcelUploadClick} alignLeft={false}
        />
      </>
    }

    <FileUploadModalSF
      context={context}
      uploadMode={mcaJsonUploadMode}
      onCancelClick={onMcaJsonCancelUploadClick}
      signedUrlApi={`/api/su/accounts/${account.accountId}/mca/report/json/fileUploadSignedUrl`}
      onUpload={onMcaJsonUpload}
    />

    <FileUploadModalSF
      context={context}
      uploadMode={mcaExcelUploadMode}
      onCancelClick={onMcaExcelCancelUploadClick}
      signedUrlApi={`/api/su/accounts/${account.accountId}/mca/report/excel/fileUploadSignedUrl`}
      onUpload={onMcaExcelUpload}
    />
  </CardUI>

export default MCADataCollectionUI